import React from 'react';
import { PreviewContentTemplate } from 'themes/components';

function PreviewContent(props) {
    return <PreviewContentTemplate {...props} />
}

export default PreviewContent;